export default function AutomationSection() {
  return (
    <section id="automation" className="py-20 bg-gray-50">
      {/* コンテンツは削除されました */}
    </section>
  );
}
